import * as React from 'react'
import classnames from 'classnames'

import OptionList from './OptionList'
import Button from '../UikButton'
import UikOutsideClickHandler from '../UikOutsideClickHandler'
import UikContentTitle from '../UikContentTitle'
import UikFormInputGroup from '../UikFormInputGroup'
import UikInput from '../UikInput'

// cls
import cls from './Select.module.scss'

class Select extends React.Component {
  static defaultProps = {
    onChange: () => {}, // eslint-disable-line
    multi: false,
    searchable: false,
    className: '',
    disabled: false,
    defaultValue: [],
    excluded: [],
    multiLimit: 0,
    value: null,
    placeholder: null,
    name: null,
    position: 'bottomLeft',
    activeValueProps: {},
    optionProps: {},
    label: null,
  }

  constructor(props, ...a) {
    super(props, ...a)
    const defaultValue = Array.isArray(props.defaultValue)
      ? props.defaultValue
      : [props.defaultValue]
    const selected = []

    props.options.forEach(item => {
      if (defaultValue.includes(item)) {
        selected.push(item)
      }
    })

    this.state = {
      selected,
      focused: false,
      isSearching: false,
      searchableText: this.writeSelected(selected),
      options: props.options,
    }
  }

  componentDidUpdate() {
    const { onChange, multi } = this.props
    if (this.callCallbackIfAvailable === true && onChange) {
      this.callCallbackIfAvailable = false
      // check if i should call onChange
      const { selected } = this.state
      if (multi) {
        onChange(selected)
      } else {
        onChange(selected[0])
      }
    }
  }

  onAllClick = (clearOnly = false) => {
    const { selected } = this.state
    const { options } = this.state
    if (selected.length >= options.length || clearOnly) {
      this.callCallbackIfAvailable = true
      this.setState({
        selected: [],
      })
    } else {
      this.onChange()
      this.setState({ selected: options.map(i => i) }) // depp copy
    }
  }

  onChange = () => {
    this.callCallbackIfAvailable = true
  }

  onToggleFocus = () => {
    const { options } = this.props
    const { focused } = this.state
    this.setState({ focused: !focused, options, searchableText: '' })
  }

  onClickUnfocus = () => {
    const { options } = this.props
    this.setState({
      focused: false,
      searchableText: this.getSearchableText(),
      options,
    })
  }

  onSearch = event => {
    const { options } = this.props
    const searchValue = event.currentTarget.value
    const filteredOptions = options.filter(
      op => op.label.toUpperCase().indexOf(searchValue.toUpperCase()) > -1
    )
    this.setState({ searchableText: searchValue, options: filteredOptions, isSearching: true })
  }

  getSearchableText = () => {
    const { disabled, value } = this.props
    const { selected: stateSelected } = this.state
    const selected = value || stateSelected
    if (disabled) {
      return ''
    }

    return this.writeSelected(selected)
  }

  writeSelected(value) {
    return value.map(el => el.label).join(', ')
  }

  getValue = () => {
    const { disabled, value } = this.props
    const { selected: stateSelected } = this.state
    const selected = value || stateSelected
    if (disabled) {
      return []
    }

    return selected
  }

  setValue = value => {
    const selected = []
    const { options } = this.state
    const values = value

    if (values.length > 0) {
      options.forEach(item => {
        if (values.indexOf(item.value) !== -1) {
          selected.push(item)
        }
      })
    }

    this.onChange()
    this.setState({ selected, searchableText: this.writeSelected(selected) })
  }

  optionClick = option => {
    const { multi } = this.props
    // single item

    if (!multi) {
      this.setState({
        selected: [option],
        focused: false,
        searchableText: option ? option.value : this.getSearchableText(),
      })
      this.onChange([option])
      return
    }

    // multiple allowed
    const { selected } = this.state
    const index = selected.map(item => item.value).indexOf(option.value)
    if (index !== -1) {
      selected.splice(index, 1)
    } else {
      selected.push(option)
    }
    this.onChange(selected)
    this.setState({ selected, searchableText: this.writeSelected(selected) })
  }

  renderHiddenInputs() {
    const { name, multi, disabled, value } = this.props

    // do not render hidden inputs if no name
    if (!name) {
      return null
    }
    const { selected: stateSelected } = this.state
    const selected = value || stateSelected
    if (disabled) {
      return null
    }
    const inputName = multi ? `${name}[]` : name

    // render selected
    return selected && selected.length > 0 ? (
      selected.map(item => (
        <input key={item.value} name={inputName} type="hidden" value={item.value} />
      ))
    ) : (
      // or render one empty
      <input name={name} type="hidden" />
    )
  }

  renderValue(textOnly) {
    const { disabled, placeholder, value } = this.props
    const { options, selected: stateSelected } = this.state
    const selected = value || stateSelected // eslint-disable-line
    const selectedIsArray = Array.isArray(selected)
    const firstRender = selectedIsArray ? selected[0] : selected
    if (typeof firstRender !== 'undefined') {
      if (!firstRender.label) {
        const full = options.find(item => firstRender.value === item.value)
        if (full) {
          firstRender.label = full.label
        }
      }
    }

    if (options.length < 1) {
      return <span className={cls.valueWrapper}>No options available</span>
    }
    if (disabled || !selected || (selectedIsArray && selected.length < 1)) {
      return (
        <span className={classnames(cls.valueWrapper, cls.placeholderEmpty)}>{placeholder}</span>
      )
    }
    if (!selectedIsArray || selected.length === 1) {
      return <div className={cls.valueWrapper}>{firstRender.label}</div>
    }
    return (
      <div className={cls.placeholderAndOther}>
        <div>{firstRender.label}</div>
        <div className={cls.plusValue}>+{selected.length - 1}</div>
      </div>
    )
  }

  render() {
    const {
      value,
      className,
      excluded,
      disabled,
      position,
      activeValueProps,
      optionProps,
      label,
      searchable,
      placeholder,
    } = this.props

    const inputValue = value?.map(el => el.label).join(', ')
    const { selected, focused, options, isSearching, searchableText } = this.state
    const { className: activeValueClassName, ...activeValuePropsRest } = activeValueProps

    return (
      <UikOutsideClickHandler
        className={classnames(cls.wrapper, className)}
        onOutsideClick={focused ? this.onClickUnfocus : null}
        onOutsideScroll={false}
      >
        {label && <UikContentTitle>{label}</UikContentTitle>}

        {searchable && (
          <UikFormInputGroup className={classnames(cls.searchableWrapper)}>
            <UikInput
              onClick={this.onToggleFocus}
              disabled={disabled}
              value={isSearching ? searchableText : inputValue}
              onChange={this.onSearch}
              placeholder={placeholder}
              className={classnames(cls.searchable, cls.valueRendered, activeValueClassName)}
            />
          </UikFormInputGroup>
        )}
        {!searchable && (
          <Button
            className={classnames(cls.valueRendered, activeValueClassName)}
            disabled={disabled || options.length < 1}
            onClick={this.onToggleFocus}
            {...activeValuePropsRest}
          >
            <div className={cls.valueRenderedWrapper}>
              {this.renderValue()}
              <div className={cls.arrowWrapper} />
            </div>
          </Button>
        )}
        {focused && !disabled && (
          <OptionList
            excluded={excluded}
            onAllClick={this.onAllClick}
            optionClick={this.optionClick}
            optionProps={optionProps}
            options={options}
            position={position}
            selected={value || selected}
          />
        )}
        {this.renderHiddenInputs()}
      </UikOutsideClickHandler>
    )
  }
}

export default Select
